import { $, $$, RM, fmt } from "./util.js";

const TYPES = {
  seeding: { post: 0.9, ppc: 1.3, vLo: 900, vHi: 3200, base: 2800, per: 14, pay: "Gifted product", payW: 25 },
  ambassador: { post: 0.97, ppc: 4, vLo: 1100, vHi: 3800, base: 3500, per: 48, pay: "Monthly fee", payW: 90 },
  affiliate: { post: 0.75, ppc: 2, vLo: 700, vHi: 2600, base: 2500, per: 10, pay: "Commission", payW: 55 },
  local: { post: 0.93, ppc: 1.5, vLo: 1400, vHi: 5200, base: 3200, per: 26, pay: "Product / visit", payW: 40 },
};

const kfmt = (v) =>
  v >= 1e6 ? (v / 1e6).toFixed(v >= 1e7 ? 0 : 1) + "M" : v >= 1e3 ? Math.round(v / 1e3) + "K" : String(Math.round(v));
const money = (v) => "$" + fmt(Math.round(v / 100) * 100);

export function initCalculator() {
  const cN = $("#cN");
  if (!cN) return;
  let cType = "seeding";
  const shown = {};

  const tween = (key, to, render, instant) => {
    const el = $(key);
    if (!el) return;
    const from = shown[key] == null ? to : shown[key];
    shown[key] = to;
    if (instant || RM || from === to) {
      el.textContent = render(to);
      return;
    }
    const s = performance.now();
    (function f(n) {
      let k = Math.min(1, (n - s) / 500);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = render(from + (to - from) * k);
      if (k < 1) requestAnimationFrame(f);
    })(s);
  };
  const bar = (id, w) => {
    const el = $(id);
    if (el) el.style.setProperty("--w", w + "%");
  };

  const update = (instant) => {
    const n = +cN.value;
    const T = TYPES[cType];
    const out = $("#cNout");
    if (out) out.textContent = n;
    cN.style.setProperty("--fill", ((n - 25) / 475) * 100 + "%");
    cN.setAttribute("aria-valuetext", n + " creators");
    const posts = Math.round(n * T.post * T.ppc);
    const fee = T.base + T.per * n;
    const hi = fee * 1.15;
    tween("#oPosts", posts, (v) => fmt(v), instant);
    tween("#oViews", posts, (v) => kfmt(v * T.vLo) + "–" + kfmt(v * T.vHi), instant);
    tween("#oCpp", fee / posts, (v) => "$" + Math.round(v), instant);
    const pay = $("#oPay");
    if (pay) pay.textContent = T.pay;
    tween("#oFee", fee, (v) => money(v * 0.9) + "–" + money(v * 1.15), instant);
    bar("#bPosts", Math.max(4, (posts / 1940) * 100));
    bar("#bViews", Math.max(4, ((posts * T.vHi) / (1940 * 5200)) * 100 * 2.2));
    bar("#bCpp", Math.max(4, Math.min(100, (fee / posts / 70) * 100)));
    bar("#bPay", T.payW);
    bar("#bFee", Math.max(4, (hi / 31700) * 100));
  };

  cN.addEventListener("input", () => update(false));

  const radios = $$("#cT [role=radio]");
  const pick = (b, focus) => {
    radios.forEach((r) => {
      const on = r === b;
      r.setAttribute("aria-checked", String(on));
      r.tabIndex = on ? 0 : -1;
    });
    cType = b.getAttribute("data-t");
    if (focus) b.focus();
    update(false);
  };
  radios.forEach((b, i) => {
    b.addEventListener("click", () => pick(b));
    b.addEventListener("keydown", (e) => {
      const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (d) {
        e.preventDefault();
        pick(radios[(i + d + radios.length) % radios.length], true);
      }
    });
  });

  update(true);
}
